import { FC } from 'react';
import BannerSection from '../../Default/BannerSection';
import LaunchSteps from '../../Default/LaunchSteps';
import TradingLevel from '../../Default/TradingLevel';
import StrategyTool from '../../Default/StrategyTool';
import SolutionSection from '../../Default/SolutionSection';
import Plans from 'ui/Plans';
import { LandingPageProps } from 'v3/pages/LandingPage/types.type';

const QubitLandingPage: FC<LandingPageProps> = (props) => {
  return (
    <div className="landing-page">
      <div className="landing-page__banner-container">
        <BannerSection />
      </div>
      <LaunchSteps />
      <TradingLevel />
      <StrategyTool />
      <SolutionSection />
      <Plans {...props} />
    </div>
  );
};

export default QubitLandingPage;
